import { useQuery } from '@tanstack/react-query';
import createPrivateAdminPanelInstance from '../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../api/ApiRoutes';

const fetchLeaguesBySportId = async (sportId) => {
  if (!sportId) return [];

  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.GET_LIVE_EVENT_ENTITIES,
    { entity_type: 'LIVE', sport_id: sportId }
  );

  return response.data?.data?.leagues ?? [];
};

export const useGetLeaguesBySportId = (sportId) => {
  return useQuery({
    queryKey: ['GET_LIVE_EVENT_ENTITIES', sportId],
    queryFn: () => fetchLeaguesBySportId(sportId),
    enabled: !!sportId,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};

